import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Splash() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/welcome');
    }, 2500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="relative flex flex-col items-center justify-center h-screen bg-gradient-to-br from-[#0F2A3A] via-[#1a3d52] to-[#0F2A3A] overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute w-96 h-96 bg-[#1ABC9C]/10 rounded-full blur-3xl -top-20 -left-20 animate-pulse"></div>
        <div className="absolute w-96 h-96 bg-[#1ABC9C]/10 rounded-full blur-3xl -bottom-20 -right-20 animate-pulse delay-700"></div>
      </div>

      {/* Logo and Content */}
      <div className="relative z-10 text-center animate-fade-in">
        <div className="w-32 h-32 mx-auto mb-8 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-3xl shadow-2xl animate-scale-in">
          <i className="ri-file-list-3-line text-7xl text-[#1ABC9C]"></i>
        </div>
        
        <h1 className="text-5xl font-bold text-white mb-4 animate-slide-up">
          منصة التقييم التعليمي
        </h1>
        
        <p className="text-xl text-white/90 font-light animate-slide-up delay-200">
          نظام الاختبارات الذكية والتقييم الفوري
        </p>

        {/* Loading Indicator */}
        <div className="mt-12 flex justify-center gap-2">
          <div className="w-3 h-3 bg-[#1ABC9C] rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-[#1ABC9C] rounded-full animate-bounce delay-100"></div>
          <div className="w-3 h-3 bg-[#1ABC9C] rounded-full animate-bounce delay-200"></div>
        </div>
      </div>

      <style>{`
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scale-in {
          from { transform: scale(0.8); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        @keyframes slide-up {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }
        .animate-scale-in {
          animation: scale-in 0.8s ease-out;
        }
        .animate-slide-up {
          animation: slide-up 0.8s ease-out;
        }
        .delay-100 {
          animation-delay: 0.1s;
        }
        .delay-200 {
          animation-delay: 0.2s;
        }
        .delay-700 {
          animation-delay: 0.7s;
        }
      `}</style>
    </div>
  );
}
